export const ADR_CHECKING_STATUS_ROUTE = 'status-adr';
